const API_ROOT = {
    development: 'https://pst-api-dev.azurewebsites.net/',
    // development: 'http://localhost:60008/',
    // inject via regex before deployment
    production: '__API_HOST__',
};

const CLIENT = {
    client_id: 'WEB',
    client_secret: 'Ideine',
};

const getRoot = () => API_ROOT[process.env.NODE_ENV] || API_ROOT.development;

const getClient = () => CLIENT;

export { getRoot, getClient };
